<template>
  <div class="t-team-box">
    <div v-for="(item, index) in listData" :key="index">
      <div class="t-team-label" :style="textStyle === '0' ? 'padding: 15px;' : 'padding: 6px;'">
        <el-popover
          placement="right"
          width="650"
          trigger="click">
          <div style="height: 500px;">
            <div style="font-weight: bold;text-align: center;padding: 5px 0;color: #0092e5;">业务员列表</div>
            <el-table v-loading="isLoading" :data="salesmanList" border size="small">
              <el-table-column property="userName" label="姓名"></el-table-column>
              <el-table-column width="105" property="phone" label="电话"></el-table-column>
              <el-table-column property="createDate" label="添加时间"></el-table-column>
            </el-table>
            <el-pagination
              small
              @current-change="handleCurrentSalesmanChange"
              :current-page="salesmanPageNo"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="salesmanTotal"
              prev-text="上一页"
              next-text="下一页">
            </el-pagination>
          </div>
          <div slot="reference" class="t-team-label-c" @click="openSalesman(item['id'])" :style="textStyle === '0' ? 'font-size: 14px;padding: 6px 12px;' : 'font-size: 12px;padding: 3px 6px;'">
            <div class="t-team-label-n" :style="textStyle === '0' ? 'font-weight: bold;' : ''">
              {{ item['userName'] }}
            </div>
            <div class="t-team-label-p">{{ item['phone'] }}</div>
            <div class="t-team-label-p">业务员数：{{ item['salesmanNum'] }}</div>
<!--        上下连接线    -->
            <div v-if="item['parentId'] !== '0'" class="t-col" :class="textStyle === '0' ? 't-tip-t' : 't-tip-t-1'"></div>
            <div v-if="item.children.length > 0" class="t-col" :class="textStyle === '0' ? 't-tip-b' : 't-tip-b-1'"></div>
          </div>
        </el-popover>
<!--        横向连接线-->
        <div v-if="listData.length > 1 && item['parentId'] !== '0' && index < 1"
             class="t-line-l t-col" :style="textStyle === '0' ? 'height: 6px' : 'height: 3px'"></div>
        <div v-if="listData.length > 1 && item['parentId'] !== '0' && index > 0"
             class="t-line-r t-col" :style="textStyle === '0' ? 'height: 6px' : 'height: 3px'"></div>
        <div v-if="listData.length > 2 && item['parentId'] !== '0' && index > 0 && index < listData.length - 1"
             class="t-line-a t-col" :style="textStyle === '0' ? 'height: 6px' : 'height: 3px'"></div>
      </div>
      <div v-if="item.children.length > 0" :key="item.id">
        <!-- 如果子级，则重新调用自己 -->
        <TeamTree :listData="item.children" :textStyle="textStyle" :dataIndex="index + 1"></TeamTree>
      </div>
    </div>
  </div>
</template>
<script setup>
import TeamTree from '@/components/public/TeamTree.vue'
export default {
  name: 'TeamTree',
  components: {
    TeamTree
  },
  data () {
    return {
      isLoading: false,
      salesmanPageNo: 1,
      salesmanTotal: 0,
      teamId: '',
      salesmanList: []
    }
  },
  props: {
    'listData': {
      type: Array,
      default: () => []
    },
    // 当前层级
    dataIndex: {
      type: Number,
      default: 0
    },
    // 姓名样式
    textStyle: {
      type: String,
      default: '0'
    }
  },
  methods: {
    openSalesman (teamId) {
      let _this = this
      _this.isLoading = true
      _this.teamId = teamId
      this.$axios.post('/salesman/salesmanList', {teamId: teamId, pageNo: _this.salesmanPageNo})
        .then((res) => {
          if (res.status === 200) {
            _this.salesmanList = res.data.rows
            _this.salesmanTotal = res.data.total
          }
          _this.isLoading = false
        })
        .catch(() => {
          _this.isLoading = false
          _this.$message.error('加载失败')
        })
    },
    // 业务员分页
    handleCurrentSalesmanChange (val) {
      this.salesmanPageNo = val
      this.openSalesman(this.teamId)
    },
    getDirection (length, index) {
      let i = index + 1
      if (((index + 0.5) === length / 2)) {
        return ''
      }
      if (i > length / 2) {
        return 't-team-label-tip-r'
      }
      if (i <= length / 2) {
        return 't-team-label-tip-l'
      }
    }
  }
}
</script>
<style scoped>
.t-team-box {
  display: flex;
  /*justify-content: center;*/
}

.t-team-label {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #000923;
  transition: padding 1s;
}

.t-col {
  background-color: #83c2e5;
  transition: all 1s;
}

.t-team-label-c {
  position: relative;
  padding: 6px 12px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);
  background-color: #83c2e5;
  transition: all 1s;
}

.t-team-label-c:hover {
  background-color: #a0cce5;
  cursor: pointer;
}

.t-tip-t {
  position: absolute;
  width: 6px;
  height: 15px;
  top: -15px;
  left: 50%;
  margin: 0 0 0 -2px;
}

.t-tip-b {
  position: absolute;
  width: 6px;
  height: 15px;
  bottom: -15px;
  left: 50%;
  margin: 0 0 0 -2px;
}

.t-tip-t-1 {
  position: absolute;
  width: 3px;
  height: 6px;
  top: -6px;
  left: 50%;
  margin: 0 0 0 -2px;
}

.t-tip-b-1 {
  position: absolute;
  width: 3px;
  height: 6px;
  bottom: -6px;
  left: 50%;
  margin: 0 0 0 -2px;
}

.t-line-l {
  position: absolute;
  top: 0;
  left: 50%;
  right: 0;
  margin: 0 0 0 -2px;
}

.t-line-r {
  position: absolute;
  top: 0;
  left: 0;
  right: 50%;
  margin: 0 0 0 -2px;
}

.t-line-a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 0 0 -1px;
}

.t-team-label-n {
  text-align: center;
  transition: font-weight 1s;
}

.t-team-label-p {
  margin: 2px 0 0 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/public/TeamTree.vue